"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this);
    _this.state = {};
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkbox, [{
    key: "onChange",
    value: function onChange(e) {
      var value = e.target && e.target.checked;
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value, this.props.name);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      // allow using space to toggle the checkbox value
      if (e.keyCode === " ") {
        e.preventDefault();
        this.ref.current.click();
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);

      if (this.props.indeterminate) {
        this.addClass("lth-is-indeterminate");
      }

      this.addClass("".concat(this.constructor.BASE_CLASS, "--").concat(this.props.size || "medium"));

      if (typeof this.props.value !== "undefined" && this.props.value !== "") {
        // if a valid value was passed through props - use that one
        if (this.state.value !== this.props.value) {
          this.setState({
            value: this.props.value
          });
        }
      }

      var message = null;

      if (this.props.message) {
        message = /*#__PURE__*/_react.default.createElement("div", {
          className: this.constructor.BASE_CLASS + "__message"
        }, this.props.message);
      }

      var label = typeof this.props.label === "undefined" ? "Checkbox label" : this.props.label;
      var labelBlock = label === null ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__label"
      }, /*#__PURE__*/_react.default.createElement("span", null, label), message);

      var indeterminateMark = this.props.indeterminate && /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__indeterminate"
      });

      var inputProps = {
        type: "checkbox",
        checked: this.props.value,
        disabled: this.props.disabled
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames(),
        tabIndex: !this.props.disabled && 0,
        onKeyDown: this.onKeyDown
      }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", _extends({}, inputProps, {
        ref: this.ref,
        onChange: this.onChange
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__control"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__check"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M3 6.3L0.5 3.8L1.3 3L3 4.7L6.7 1L7.5 1.8L3 6.3Z",
        fill: ""
      }))), indeterminateMark)), labelBlock));
    }
  }]);

  return Checkbox;
}(_component.default);

exports.default = Checkbox;

_defineProperty(Checkbox, "BASE_CLASS", "lth-c-checkbox");

Checkbox.METADATA = {
  name: "Checkbox",
  description: "Use to allow merchants to provide text input when the expected input is short. For longer input, use the auto grow or multiline options.",
  props: [{
    name: "label",
    type: "string",
    description: "Input label"
  }, {
    name: "value",
    type: "string",
    options: [{
      value: undefined,
      label: "Not set"
    }, {
      value: true,
      label: "Checked"
    }, {
      value: false,
      label: "Unchecked"
    }]
  }, {
    name: "size",
    type: "string",
    options: [{
      value: "medium"
    }, {
      value: "small"
    }]
  }, {
    name: "indeterminate",
    type: "boolean",
    category: "value"
  }, {
    name: "disabled",
    type: "boolean",
    description: "Set disabled state"
  }, {
    name: "error",
    type: "boolean",
    description: "Set error state"
  }, {
    name: "forcehover",
    type: "boolean",
    default: false,
    description: "Force hover state."
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false,
    description: "Force focus state."
  }, {
    name: "message",
    type: "string",
    description: "Message displayed in the component"
  }, {
    name: "onChange",
    type: "function"
  }]
};